// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-image {
    opacity: 0;
    transition: opacity 1s ease-in-out;
}
.carousel-image.active {
    opacity: 1;
}
.logo{ 
    filter: brightness(10%);
    filter: contrast(0%);  
}

.img{
    filter: brightness(60%);
}


 /* .filter-container {
    position: absolute;
    top: 100px;
    left: 0;
    right: 2;
    display: flex;
    justify-content: center;
    z-index: 1001; /* Ensure it's above the overlay */
  /* } */

  /*.filter-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Transparent black overlay */
    /* z-index: 1000; */
     /* Ensure it's above other elements */
  /* } */

  .blur {
    filter: blur(5px); /* Apply blur effect */
  }
  .text-highlight{
    -webkit-text-stroke:1px #646e75;
    -webkit-text-stroke:2px #c4d3dd;
  }

  .colorChangeImg {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(200%) contrast(200%);
    
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/carousal.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kCAAkC;AACtC;AACA;IACI,UAAU;AACd;AACA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;;CAGC;;;;;;;qDAOoD;EACnD,MAAM;;EAEN;;;;;;wEAMsE;IACpE,mBAAmB;KAClB,qCAAqC;EACxC,MAAM;;EAEN;IACE,iBAAiB,EAAE,sBAAsB;EAC3C;EACA;IACE,+BAA+B;IAC/B,+BAA+B;EACjC;;EAEA;IACE,4FAA4F;;EAE9F","sourcesContent":[".carousel-image {\n    opacity: 0;\n    transition: opacity 1s ease-in-out;\n}\n.carousel-image.active {\n    opacity: 1;\n}\n.logo{ \n    filter: brightness(10%);\n    filter: contrast(0%);  \n}\n\n.img{\n    filter: brightness(60%);\n}\n\n\n /* .filter-container {\n    position: absolute;\n    top: 100px;\n    left: 0;\n    right: 2;\n    display: flex;\n    justify-content: center;\n    z-index: 1001; /* Ensure it's above the overlay */\n  /* } */\n\n  /*.filter-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Transparent black overlay */\n    /* z-index: 1000; */\n     /* Ensure it's above other elements */\n  /* } */\n\n  .blur {\n    filter: blur(5px); /* Apply blur effect */\n  }\n  .text-highlight{\n    -webkit-text-stroke:1px #646e75;\n    -webkit-text-stroke:2px #c4d3dd;\n  }\n\n  .colorChangeImg {\n    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(200%) contrast(200%);\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
